import * as constants from '../constants';
import update from 'immutability-helper';

const INITIAL_STATE = {
    templates: [],
    generalErrorText: null
};

const templates = (state = INITIAL_STATE, action) => {
    let newState;
    switch (action.type) {
        case constants.ACTION_TYPE_TEMPLATES__GET_WEB_ACCOUNT_TEMPLATES_SUCCESS:
            newState = update(state, {
                generalErrorText: { $set: null },
                templates: { $set: action.data.templates }
            });
            console.log(action.type, state, newState);
            return newState;
        case constants.ACTION_TYPE_TEMPLATES__GET_WEB_ACCOUNT_TEMPLATES_FAIL:
            newState = update(state, {
                generalErrorText: { $set: action.data.generalErrorText },
                templates: { $set: [] }
            });
            console.log(action.type, state, newState);
            return newState;
        default:
            return state;
    }
}

export default templates;